import React from 'react';
import { css } from '@emotion/react';

const navItems = ['Emails', 'Forms', 'Workflows', 'Checkouts', 'Products', 'Audience', 'Analytics'];

const navStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 96px;
  padding: 0 40px;
  background: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
  position: sticky;
  top: 0;
  z-index: 10;
`;

const logoStyles = css`
  width: 124px;
  height: auto;
  flex-shrink: 0;
`;

const linksStyles = css`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const linkStyles = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.16px;
  color: rgba(61, 46, 41, 0.52);
  cursor: pointer;
  text-decoration: none;

  &:first-of-type {
    color: #121212;
  }
`;

const dividerStyles = css`
  width: 1px;
  height: 16px;
  background: rgba(61, 46, 41, 0.2);
`;

const profileAreaStyles = css`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const avatarStyles = css`
  width: 40px;
  height: 40px;
  border-radius: 100px;
  border: 1px solid rgba(61, 46, 41, 0.24);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: black;
`;

const chevronStyles = css`
  width: 10px;
  height: 14px;
  display: flex;
  align-items: center;
  color: rgba(61, 46, 41, 0.52);
`;

export default function TopNav() {
  return (
    <nav css={navStyles}>
      <img css={logoStyles} src="/flodesk.png" alt="Flodesk" />
      <div css={linksStyles}>
        {navItems.map(item => (
          <React.Fragment key={item}>
            {item === 'Products' && <span css={dividerStyles} />}
            <span css={linkStyles}>{item}</span>
          </React.Fragment>
        ))}
      </div>
      <div css={profileAreaStyles}>
        <div css={avatarStyles}>C</div>
        <svg css={chevronStyles} viewBox="0 0 10 6" fill="none">
          <path
            d="M1 1L5 5L9 1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </nav>
  );
}
